import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Validators, FormControl } from '@angular/forms';

import { Router } from '@angular/router';
import { AuthService } from 'my-lib-sanfelici';



@Component({
  selector: 'app-login-mail',
  templateUrl: './login-mail.component.html',
  styleUrls: ['./login-mail.component.css']
})
export class LoginMailComponent implements OnInit {
  errorMessage: string;
  error: {name: string, message: string} = {name: '', message: ''};
  resetPassword = false;
  email = new FormControl('', [Validators.required, Validators.email]);
  password = new FormControl('', [Validators.required]);
  constructor(
    private router: Router,
    private authservice: AuthService,
    public dialogRef: MatDialogRef<LoginMailComponent>
  ) { }


  ngOnInit() {
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  getErrorMessage() {
    return this.email.hasError('required') ? 'inserisci email' :
        this.email.hasError('email') ? 'email non valida' : '';
  }
  getErrorPassword() {
    return this.password.hasError('required') ? 'inserisci password' : '';
  }
  getErrorPasswordInvalid() {
    return 'Password non valida';
  }

  login(email: string, password: string) {
    this.authservice.loginEmail(email, password).then((u) => {
this.router.navigate(['/myuser','contatti','edit',u.uid]);
this.dialogRef.close();
    })
    .catch(() => {
     alert('password errata');


    });

   }




}
